<template>
  <li class="menu-item">
    <slot></slot>
  </li>
</template>

<script>
export default {
  name: 'ContextMenuItem'
}
</script>

<style scoped>
.menu-item {
  display: flex;
  cursor: pointer;
  align-items: center;
  border-bottom: thin solid #00654C;
}
.menu-item:hover {
  background-color: #CCFFF2;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/ContextMenuItem.vue